import { HStack } from '@chakra-ui/react';
import { useRematchDispatch, useRematchSelector } from 'models/rematchStore';
import { FeedStatus } from './FeedStatus';
import { getErroredSystems } from './SystemStatuses.utils';
import { useEffect } from 'react';

export const SystemStatuses = ({ parkName }) => {
    const systems = useRematchSelector((state) => state.parksData.systems);
    const dispatch = useRematchDispatch();

    const parkSystems = systems[parkName] || [];

    useEffect(() => {
        dispatch({ type: 'systemStatus/initializeSystemStatus' });
    }, []);

    return (
        <HStack gap={3}>
            {getErroredSystems(parkSystems).map((system) => (
                <FeedStatus name={system.name} />
            ))}
        </HStack>
    );
};
